export default __webpack_public_path__ + "static/media/star.59f136c8.svg";